import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../../services/axios-client"

const useListRole = () => {
    const [payload, setPayload] = useState([])
    const [loadingPagestate, setLoadingPage] = useState(false)

    const getRoles = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get('/auth/roles')
            setPayload(res.data.data)
            setLoadingPage(false)
            return (res.data.data)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteRole = async (id, onSuccess) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.delete(`/auth/roles/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Role")
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        getRoles,
        deleteRole,
        loadingPagestate
    }
}

export default useListRole